/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import Card from '../../../components/card';
import Title from '../../../components/title';
import { ReportMenu } from '@/configs/menuItems';
import { getPathSegment } from '@/utils/pathUtils';
import SubMenu from '@/components/menu/sub-menu';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { searchSafetyStockReport } from '@/adapters/report';
import {
  ISearchSafetyStockReportReq,
  ISearchSafetyStockReportRes,
} from '@/interfaces/report';
import Search from 'antd/es/input/Search';
import SafetyStockReportTable from './components/stock-report-table';
import ExcelExport from './components/export-report';
import BusinessUnitSelector from '@/components/selector/business-unit-selector';
import { useAuth } from '@/contexts/AuthContext';
// import ExcelExport from './components/export-report';

const _criteria: ISearchSafetyStockReportReq = {
  productName: '',
};

const StockReport: React.FC = () => {
  const pathSegment = getPathSegment();
  const { userInfo } = useAuth();
  const [criteria, setCriteria] = useState<ISearchSafetyStockReportReq>({
    ..._criteria,
    businessUnitId: userInfo?.bu || undefined,
  });
  const [margin] = useState<number>(0);
  const { data, isLoading } = useQuery<
    AxiosResponse<ISearchSafetyStockReportRes[]>,
    Error
  >({
    queryKey: ['search-safety-stock-report', criteria],
    queryFn: async () => await searchSafetyStockReport(criteria),
  });

  const onSearch = (text: string) => {
    setCriteria({
      ...criteria,
      productName: text,
    });
  };

  const reports = (data?.data || []).map((c, idx) => {
    c.id = idx + 1;
    return c;
  });

  return (
    <>
      <SubMenu active={pathSegment} items={ReportMenu} />
      <Card customClass="min-h-[200px]">
        <Title title="Safety Stock Report">
          <ExcelExport
            data={reports?.sort(
              (a, b) =>
                Number(a.remainStock - a.safetyStock) -
                Number(b.remainStock - b.safetyStock),
            )}
          />
        </Title>
        <div className="flex flex-col gap-3">
          <div className="flex flex-col md:flex-row justify-between gap-3">
            <div className="flex flex-col md:flex-row justify-between gap-3">
              <BusinessUnitSelector
                handleSelectData={function (id: number): void {
                  setCriteria({ ...criteria, businessUnitId: id });
                }}
                disabled={!!userInfo?.bu}
                value={criteria.businessUnitId}
              />
              <Search
                className="md:max-w-[400px] md:min-w-[400px]"
                placeholder="ค้นหา"
                allowClear
                size="large"
                enterButton="ค้นหา"
                onSearch={onSearch}
              />
              {/* <InputNumber
                size="large"
                placeholder="margin ($)"
                suffix={'%'}
                controls={false}
                value={margin}
                onChange={v => setMargin(Number(v || 0))}
              /> */}
            </div>
          </div>
          <SafetyStockReportTable
            margin={margin}
            report={reports || []}
            loading={isLoading}
            onTableChange={() => console.log()}
          />
        </div>
      </Card>
    </>
  );
};

export default StockReport;
